import * as Yup from 'yup'

const signUpEmailVerificationSchema = Yup.object().shape({
  code: Yup.string().length(6, 'validation-code-length').required('validation-required'),
})

export { signUpEmailVerificationSchema }
